import { useIsomorphicLayoutEffect } from "@tamagui/constants";
import { useEvent } from "@tamagui/use-event";
import { getBoundingClientRect } from "../helpers/getBoundingClientRect";
import { getRect } from "../helpers/getRect";
const LayoutHandlers = /* @__PURE__ */ new WeakMap();
let resizeObserver = null;
if (typeof window !== "undefined" && "ResizeObserver" in window) {
  resizeObserver = new ResizeObserver((entries) => {
    for (const { target } of entries) {
      const onLayout = LayoutHandlers.get(target);
      if (typeof onLayout !== "function")
        return;
      measureLayout(target, null, (x, y, width, height, left, top) => {
        onLayout({
          nativeEvent: {
            layout: { x, y, width, height, left, top },
            target
          },
          timeStamp: Date.now()
        });
      });
    }
  });
}
const measureLayout = (node, relativeTo, callback) => {
  const relativeNode = relativeTo || (node == null ? void 0 : node.parentNode);
  if (relativeNode instanceof HTMLElement) {
    setTimeout(() => {
      const relativeRect = getBoundingClientRect(relativeNode);
      const { height, left, top, width } = getRect(node);
      const x = left - relativeRect.left;
      const y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};
const idFn = () => {
};
function useElementLayout(ref, onLayout) {
  const hasLayoutEvent = !!onLayout;
  const onLayoutEvent = useEvent(onLayout || idFn);
  useIsomorphicLayoutEffect(() => {
    if (!resizeObserver || !hasLayoutEvent)
      return;
    const node = ref.current;
    if (!node)
      return;
    LayoutHandlers.set(node, onLayoutEvent);
    resizeObserver.observe(node);
    return () => {
      resizeObserver == null ? void 0 : resizeObserver.unobserve(node);
    };
  }, [ref, hasLayoutEvent]);
}
export {
  measureLayout,
  useElementLayout
};
//# sourceMappingURL=useElementLayout.js.map
